import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getDashboardStats() {
  return getRequest(
    `Dashboard/stats`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getDashboardRecruiterStats(recruiterId) {
  return getRequest(
    `Dashboard/stats/${recruiterId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}


export const dashboardService = {
  getDashboardStats,
  getDashboardRecruiterStats
};
